import template from './employee-card.html';
import controller from './employee-card.controller';

let employeeCardComponent = {
  restrict: 'E',
  bindings: {
    employeeId: '<',
    profilePic: '<',
    firstName: '<',
    lastName: '<'
  },
  template,
  controller
};

export default employeeCardComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/components/employee-card/employee-card.component.js